<template>
  <v-app>
    <div v-if="user && $route.name != 'UnauthorizedAccess'">
      <v-app-bar class="pl-2" app color="white" height="60" flat style="color:#343056">
        <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="font-weight-light d-none d-sm-flex">
          <h1 class="headline font-weight-medium teal--text text--accent-3" v-if="$route.name === 'UsersList' || $route.name === 'Ambulances' || $route.name === 'Hospitals' || $route.name === 'AbsenceReport' || $route.name === 'NursingStaff' || $route.name === 'GeneralFleet' || $route.name === 'UsersRules' || $route.name === 'Bases' || $route.name === 'Hospital' || $route.name === 'Relatorios'">Administrador</h1>
          <h1 class="headline font-weight-medium teal--text text--accent-3" v-if="$route.name === 'DoctorCalls'">Médico Regulador</h1>
          <h1 class="headline font-weight-medium teal--text text--accent-3" v-if="$route.name === 'TarmCalls'">Tarm</h1>
          <h1 class="headline font-weight-medium teal--text text--accent-3" v-if="$route.name === 'FleetManager'">Gestor de Frota</h1>
        </v-toolbar-title>
        <v-toolbar-items v-if="$store.getters.userRule.includes('admin') && $route.name != 'FleetManager' && $route.name != 'TarmCalls' && $route.name != 'DoctorCalls'" class="ml-6 py-3">
          <v-btn
            class="body-2 blue--text"
            style="text-transform: none"
            @click="$router.push('/userslist')"
            depressed
          >Usuários</v-btn>
          <v-btn
            class="body-2 blue--text ml-3"
            style="text-transform: none"
            @click="$router.push('/ambulances')"
            depressed
          >Ambulâncias</v-btn>
          <v-btn
            class="body-2 blue--text ml-3"
            style="text-transform: none"
            @click="$router.push('/Bases')"
            depressed
          >Bases</v-btn>
          <v-btn
            class="body-2 blue--text ml-3"
            style="text-transform: none"
            @click="$router.push('/hospital')"
            depressed
          >Hospital</v-btn>
          <v-btn
            class="body-2 blue--text ml-3"
            style="text-transform: none"
            @click="$router.push('/generalfleet')"
            depressed
          >Relatórios</v-btn>
          <!--          <v-btn
                            class="body-2 blue&#45;&#45;text ml-3"
                            style="text-transform: none"
                            @click="$router.push('/absencereport')"
                            depressed
                    >Frequência</v-btn>-->
          <!--            <v-btn
                            class="body-2 blue&#45;&#45;text ml-3"
                            style="text-transform: none"
                            @click="$router.push('/nursingstaff')"
                            depressed
                    >Quadro de colaboradores</v-btn>-->
        </v-toolbar-items>

        <v-spacer></v-spacer>

        <!--         <div width="40" >
              <v-text-field dense class="mt-6" height="10" filled label="Buscar" prepend-inner-icon="fas fa-search"></v-text-field>
                </div>
                 <v-btn icon>
                  <v-icon size="20">fas fa-bell</v-icon>
                </v-btn>-->

        <v-menu right offset-y min-width="400">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-avatar size="37">
                <img v-if="user.avatar && user.avatar.url" :src="user.avatar.url" alt="Foto-Avatar" />
                <v-icon v-else large>account_circle</v-icon>
              </v-avatar>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img v-if="user.avatar && user.avatar.url" :src="user.avatar.url" alt="Foto-Avatar" />
                  <v-icon v-else large>account_circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="headline grey--text text--darken-1 font-weight-regular ">{{user.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="userProfile">
                <v-list-item-icon>
                  <v-icon color="success">far fa-id-card</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="grey--text text--darken-1">
                  <v-list-item-title class="font-weight-medium">Perfil</v-list-item-title>
                  <v-list-item-subtitle class="font-weight-regular">Editar informações do perfil</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>

            <v-list>
              <v-list-item
                v-if="this.$store.getters.userRule.includes('admin')"
                class="px-8"
                @click="userAdm"
              >
                <v-list-item-icon>
                  <v-icon large color="red lighten-2">admin_panel_settings</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="grey--text text--darken-1">
                  <v-list-item-title class="font-weight-medium">Administrador</v-list-item-title>
                  <v-list-item-subtitle class="font-weight-regular">Entre no módulo do administrador</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                v-if="this.$store.getters.userRule.includes('admin') || this.$store.getters.userRule.includes('nurse')"
                class="px-8"
                @click="userMedico"
              >
                <v-list-item-icon>
                  <v-icon large color="blue darken-1">fas fa-user-md</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="grey--text text--darken-1">
                  <v-list-item-title class="font-weight-medium">Médico Regulador</v-list-item-title>
                  <v-list-item-subtitle class="font-weight-regular">Entre no módulo do médico regulador</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                v-if="this.$store.getters.userRule.includes('admin')"
                class="px-8"
                @click="userTarm"
              >
                <v-list-item-icon>
                  <v-icon large color="orange lighten-1">fas fa-notes-medical</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="grey--text text--darken-1">
                  <v-list-item-title class="font-weight-medium">Tarm</v-list-item-title>
                  <v-list-item-subtitle class="font-weight-regular">Entre no módulo do Tarm</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                v-if="this.$store.getters.userRule.includes('admin')"
                class="px-8"
                to="FleetManager"
              >
                <v-list-item-icon>
                  <v-icon large color="purple lighten-1">fas fa-ambulance</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="grey--text text--darken-1">
                  <v-list-item-title class="font-weight-medium">Gestor de frota</v-list-item-title>
                  <v-list-item-subtitle class="font-weight-regular">Entre no módulo do Gestor de frota</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="logOut">Sair</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        class="d-none d-md-block text-center"
        width="100"
        app
        :permanent="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'?false:true"
        color="teal accent-3"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="my-0 py-0 headline font-weight-bold white--text">
              SAMU
              <br />192
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list dense>
          <v-list-item class="text-center">
            <v-list-item-action class="ml-0">
              <v-btn color="teal accent-3" text @click="$router.push('/')">
                <v-icon class="white--text">fas fa-home</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="drawer"
        class="d-md-none text-center"
        width="100"
        temporary
        color="teal accent-3"
        fixed
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="my-0 py-0 headline font-weight-bold white--text">
              SAMU
              <br />192
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list dense>
          <v-list-item class="text-center">
            <v-list-item-action class="ml-0" @click="$router.push('/')">
              <v-btn color="teal accent-3" text>
                <v-icon class="white--text">fas fa-home</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    drawer: false
  }),
  mounted(){
    localStorage.setItem('teste',"teste bem sucedido")
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    acceptedTerm() {
      return this.$store.getters.acceptedTerm;
    }
  },
  watch: {
    user() {
      var value = this.user;
      if (!value) {
        this.$router.push("/");
      }
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch("logOut");
    },
    userProfile() {
      this.$router.push("/profile");
    },
    userMedico() {
      this.$router.push("/doctorcalls");
    },
    userAdm() {
      this.$router.push("/userslist");
    },
    userTarm() {
      this.$router.push("/tarmcalls");
    },
    titleUserSistem() {
      return this.$store.getters.userRule.includes('tarm')
        ? "Tarm"
        : this.$store.getters.userRule.includes("medico")
          ? "Médico Regulador"
          : "Administrador";
    }
  }
};
</script>
